<template>
  <el-dialog
    title="Connection Settings"
    :visible.sync="dialog_visible"
    width="75%"
    @open="onLoad">

    <div class="d-block">
      <!-- TODO: sync with wiazrd -->

      <el-row :gutter="20">

        <el-col :span="14">
          <h3>Trello</h3>
          <div class="small" style="font-size: 9pt">
            Trello is a collaboration tool that organizes your projects into boards. In one glance, Trello tells you what's being worked on, who's working on what, and where something is in a process.
          </div>
        </el-col>
        <el-col :span="10">
          <el-button v-if="trello_authorized !== 1" round class="mt-6 ml-4" @click="onConnectTrello()">Connect</el-button>
          <el-button v-else round class="mt-6 ml-4" @click="onDisconnectTrello()" type="danger">Disconnect</el-button>
          <span v-if="trello_authorized === -1">Connection failed</span>
          <div v-if="trello_auth_date"><strong>Token created:</strong> {{trello_auth_date|fromNow}}</div>
        </el-col>

        <el-col>&nbsp;</el-col>

        <el-col :span="14" class="pt-6">
          <h3>Google Calendar</h3>
          <div class="small" style="font-size: 9pt">
            Google Calendar is a time-management and scheduling calendar service developed by Google.
          </div>
        </el-col>
        <el-col :span="10">
          <el-button v-if="google_calendar_authorized !== 1" round class="mt-6 ml-4" @click="onConnectGoogleCalendar()">Connect</el-button>
          <el-button v-else round class="mt-6 ml-4" @click="onDisconnectGoogleCalendar()" type="danger">Disconnect</el-button>
          <span v-if="google_calendar_authorized === -1">Connection failed</span>
          <div v-if="google_calendar_auth_date"><strong>Token created:</strong> {{google_calendar_auth_date|fromNow}}</div>
        </el-col>
      </el-row>

      <!--
      <hr />

      <div class="sub-title">Calendar Provider:</div>
      <el-radio-group v-model="clone.provider">
        <el-radio label="google">Google</el-radio>
        <el-radio label="outlook">Outlook</el-radio>
        <el-radio label="apple">Apple</el-radio>
      </el-radio-group>

      <div class="sub-title">API Key:</div>
      <el-input placeholder="Please input" v-model="clone.apikey" class="inline-input"></el-input>
      -->

      <!-- <pre>{{clone}}</pre> -->
    </div>

    <span slot="footer">
      <el-button type="primary" @click="onSaveSettings">Save</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      dialog_visible: false,
      clone: {}
    }
  },
  computed: {
    ...mapGetters("user", [
      "userData"
    ]),

    ...mapGetters("trello", [
      "trello_authorized",
      "trello_auth_date"
    ]),

    ...mapGetters("calendar", [
      "google_calendar_authorized",
      "google_calendar_auth_date"
    ]),
  },
  methods: {
    ...mapActions("trello", [
      "trello_auth",
      "trello_unauth"
    ]),

    ...mapActions("calendar", [
      "google_calendar_auth",
      "google_calendar_unauth"
    ]),

    showModal() {
      this.dialog_visible = true;
    },
    onLoad() {
      if ( this.userData  && 'connectionSettings' in this.userData) {
        this.clone = Object.assign({}, this.userData.connectionSettings)
      }
    },
    onConnectTrello() {
      this.trello_auth(true);
    },
    onDisconnectTrello() {
      this.trello_unauth();
    },
    onConnectGoogleCalendar() {
      this.google_calendar_auth(true);
    },
    onDisconnectGoogleCalendar() {
      this.google_calendar_unauth();
    },
    onSaveSettings() {
      this.$api.user_update_settings_by_prefix({
        data: this.clone,
        prefix: 'connectionSettings'
      }).then(() => {
        console.log( "Successfully updated user connectionSettings" );
        this.dialog_visible = false;
        this.$emit('save');
      });
    },
  }
};
</script>
